import {LiveblogWidgetInitialData, SortOrder} from "@webng-types/embedjs";
import {useApi} from "@webng/react-app-common";
import {ApiClient, isApiResponseError} from "@webng/tickaroo-api";
import {useEffect, useState} from "react";
import {liveblogThemeConfigurationSchema} from "@webng-types/embedjs/liveblog";
import {sharedThemeConfigurationSchema} from "@webng-types/embedjs/shared";

interface UseLiveblogWidgetDataProps {
  clientId: string
  themeId: string
  liveblogId: string
  limit?: number
  sort?: SortOrder
  initialData?: LiveblogWidgetInitialData
}

interface Query {
  client_id: string
  themeId: string
  liveblogId: string
  limit?: number
  sort?: SortOrder
}

export function useLiveblogWidgetData({clientId, themeId, liveblogId, limit, sort, initialData}: UseLiveblogWidgetDataProps) {
  const apiClient = useApi()
  const [data, setData] = useState<LiveblogWidgetInitialData>(() => {
    if(initialData) {
      if(initialData.configuration && !initialData.liveblogThemeConfiguration) {
        return {
          ...initialData,
          liveblogThemeConfiguration: liveblogThemeConfigurationSchema.parse(initialData.configuration),
          sharedThemeConfiguration: sharedThemeConfigurationSchema.parse(initialData.configuration)
        }
      } else {
        return initialData
      }
    } else {
      return {}
    }
  })
  const [error, setError] = useState<number|undefined>(undefined)

  useEffect(() => {
    if(!data.configuration && !data.liveblogThemeConfiguration) {
      const query: Query = {client_id: clientId, themeId, liveblogId}
      if(limit){
        query["limit"] = limit;
      }
      if(sort){
        query["sort"] = sort;
      }

      apiClient.getJson(ApiClient.API_EMBED_V4_LIVEBLOG, query)
        .then((d: LiveblogWidgetInitialData) => {
          if(d.liveblogThemeConfiguration) {
            return d
          } else {
            return {
              ...d,
              liveblogThemeConfiguration: liveblogThemeConfigurationSchema.parse(d.configuration),
              sharedThemeConfiguration: sharedThemeConfigurationSchema.parse(d.configuration)
            }
          }
        })
        .then(setData)
        .catch(e => {
          if(isApiResponseError(e)) {
            setError(e.status)
          } else {
            console.error(e)
            setError(0)
          }
        })
    }
  }, [apiClient, clientId, themeId, liveblogId, data, setData, setError, limit, sort])

  return {
    ...data,
    error
  }
}
